import { IsNotEmpty, IsString } from 'class-validator';

import { UserDto } from './user-dto';

export class LoginAccessTokenDto {
    @IsNotEmpty()
    user!: UserDto;

    @IsString()
    @IsNotEmpty()
    access_token!: string;

    @IsString()
    @IsNotEmpty()
    refresh_token!: string;
}
